export class CentralStationContactPatientUpdateRequestDto {
    DateOfBirth: string;
    DateOfBirthChangeFlag: boolean;
}